import { Box, TextField, Typography } from "@mui/material";
import QuestionFileUpload from "../../QuestionFileUpload";
import { useState } from "react";

const TimeQuestion = ({ q, sectionIndex, error, handleChange, formData, setFormData, isDisabled, handleFiles   }) => {
  const [answers, setAnswers] = useState((q.answers || []))
  
  return (
    <Box>
      <TextField
        type="time"
        fullWidth
        value={answers?.[0]?.replace("\\","") || ''}
        onChange={(e) => {
          if (handleChange) {
            handleChange(sectionIndex, q, [e.target.value])
            setAnswers([e.target.value])
          }
        }}
      />
      <QuestionFileUpload q={q} sectionIndex={sectionIndex}  isDisabled={isDisabled} handleFiles={handleFiles} />
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TimeQuestion;
